module.exports = __webpack_public_path__ + "static/androidBannerMasterpass2-e3f64a87fd7b20086bb17eebfd7dcce3.png";